import { TranslationKey } from '@hermes/translations'

export const getNameError = (name: string, fieldName: 'firstName' | 'lastName'): TranslationKey | undefined => {
  const nameRegex = /^[\p{Letter}]+([ \-'.]?[\p{Letter}]+)*$/u
  const fieldType = fieldName === 'firstName' ? 'firstName' : 'lastName'

  if (!name || name.trim().length === 0) {
    return `validation.message.${fieldType}.required`
  }

  if (name.length > 50) {
    return 'validation_name_length'
  }

  if (!nameRegex.test(name.trim())) {
    return 'validation_name_invalid_chars'
  }

  return undefined
}

// Should we change policy? Non-latin is allowed 👇
// Examples of valid names:
// - John, María, François, Müller, O'Connor, Jean-Pierre, José María
// - Søren, Björk, Åse, Łukasz, Żółć
// Examples of invalid names:
// - John123, J@hn, _John_, John!, John--Smith
